import { useTranslation } from 'react-i18next'
import { useThemeStore } from '../stores/theme.store'

/**
 * Light/dark toggle. Icon-only by design — every header already carries the
 * locale switcher and notifications bell, so this stays compact and relies
 * on an accessible label rather than visible text.
 */
export function ThemeToggle() {
  const { t } = useTranslation('common')
  const theme = useThemeStore((state) => state.theme)
  const toggle = useThemeStore((state) => state.toggle)
  const isDark = theme === 'dark'

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={isDark}
      aria-label={isDark ? t('theme.switchToLight') : t('theme.switchToDark')}
      title={isDark ? t('theme.switchToLight') : t('theme.switchToDark')}
      className="flex h-touch w-touch items-center justify-center rounded-input text-ink hover:bg-surface-sunken dark:text-surface dark:hover:bg-surface-dark-raised"
    >
      <span aria-hidden="true">{isDark ? '\u2600' : '\u263D'}</span>
    </button>
  )
}
